import * as React from 'react';

interface Props {
  className?: string;
  onClick?: (e: any) => void;
}
const TR: React.FC<Props> = ({ children, className = '', onClick }) => (
  <tr className={className || ''} onClick={onClick}>
    {children}
  </tr>
);

export default TR;
